import type { Tree, TreeNode } from './typeHelpers.no-deps'

/**
 * Visit every node in a tree
 */
export function* treeIterator<T>(tree: Tree<T>): IterableIterator<TreeNode<T>> {
    for (const node of tree) {
        yield node
        if (node.children.length === 0) continue
        yield* treeIterator(node.children)
    }
}

/**
 * Visit every leaf node in a tree
 */
export function* leavesIterator<T>(tree: Tree<T>): IterableIterator<TreeNode<T>> {
    for (const node of treeIterator(tree)) {
        if (node.children.length === 0) yield node
    }
}

export const getTreeNodes = <T>(tree: Tree<T>) => [...treeIterator(tree)]
export const getLeaves = <T>(tree: Tree<T>) => [...leavesIterator(tree)]
